const handleErrorAsync = (error, setErrorMsg) => {
    // Máy chủ dự phòng khoá thao tác chi tiền: backend trả 503 kèm cờ `standby` và một
    // lời nhắn viết sẵn cho user. Phải hiện nguyên văn — nhánh 5xx bên dưới thay bằng
    // "Đã có lỗi xảy ra (code: 503)" thì user không hiểu vì sao, bấm lại chục lần rồi
    // nhắn hỗ trợ. App đã hiện đúng lời nhắn này, web trước giờ thì không.
    if (error.response?.data?.standby && error.response?.data?.message) {
        return setErrorMsg(error.response.data.message);
    }

    if (`${error.response?.status}`.startsWith('5')) {
        return setErrorMsg(
            `Đã có lỗi xảy ra, vui lòng thử lại sau (code: ${error.response.status})`
        );
    }
    if (`${error.response?.status}`.startsWith('4')) {
        const message = error.response?.data?.message || error.response?.data?.error?.message || 'Đã có lỗi xảy ra';
        
        // Cải thiện thông báo cho một số lỗi phổ biến
        if (message.includes('Không tìm thấy đơn hàng')) {
            return setErrorMsg(
                'Không tìm thấy đơn hàng! Vui lòng kiểm tra lại mã đơn hàng hoặc đợi sau 48 giờ kể từ khi đặt hàng.'
            );
        }
        if (message.includes('đã được xác nhận')) {
            return setErrorMsg(message);
        }
        
        return setErrorMsg(message);
    }

    // Xử lý trường hợp không có response (network error, etc.)
    if (error.message) {
        return setErrorMsg(error.message);
    }

    return setErrorMsg('Lỗi không xác định, vui lòng thử lại sau');
};

export default handleErrorAsync;
